import {
  UPDATE_GPT_RECOMMENDATION_PAGE_NUMBER,
  GET_GPT_RECOMMENDATION_PENDING,
  GET_GPT_RECOMMENDATION,
  DELETE_GPT_RECOMMENDATION,
  FETCH_GPT_RECOMMENDATION,
  EDIT_GPT_RECOMMENDATION,
  ADD_GPT_RECOMMENDATION,
  CLEAR_GPT_RECOMMENDATION,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  gpt_recommendation: [],
  deleted: null,
  updated: null,
  pending: false,
  pageNumber: 1,
};

export default function GptRecommendation(state = initialState, action) {
  switch (action.type) {
    case GET_GPT_RECOMMENDATION_PENDING:
      return {
        ...state,
        pending: true,
      };
      
    case UPDATE_GPT_RECOMMENDATION_PAGE_NUMBER:
      return {
          ...state,
          pageNumber: action.payload,
        };

    case GET_GPT_RECOMMENDATION:
      return {
        ...state,
        gpt_recommendation: action.payload,
        pending: false,
      };

    case FETCH_GPT_RECOMMENDATION:
      return { 
          ...state, 
          [action.payload.id]: action.payload, 
          pending: false 
        };

    case EDIT_GPT_RECOMMENDATION:
      return { 
        ...state, 
        updated: action.payload,
        pending: false,
      };

    case DELETE_GPT_RECOMMENDATION:
      return {
        ...state,
        deleted: action.payload,
        pending: false,
      };

    case ADD_GPT_RECOMMENDATION:
      return {
        ...state,
        gpt_recommendation: [...state.gpt_recommendation, action.payload],
        pending: false,
      };

    case CLEAR_GPT_RECOMMENDATION:
      return {
        ...state,
        gpt_recommendation: [],
        deleted: null,
        updated: null,
        pending: false,
        pageNumber: 1,
      };

    case CLEAR_ALL:
      return {
        ...state,
        gpt_recommendation: [],
        deleted: null,
        updated: null,
        pending: false,
        pageNumber: 1,
      };

    default:
      return state;
  }
}
